import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';

export type ProcessingLoaderAppearance = 'inline' | 'overlay';

type ProcessingLoaderTranslations = {
  [key: string]: string;
};

const DEFAULT_MESSAGE_COUNT = 10;

@Component({
  selector: 'app-processing-loader',
  templateUrl: './processing-loader.html',
  styleUrl: './processing-loader.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-live': 'polite',
    'aria-atomic': 'true',
    '[class.is-overlay]': "appearance() === 'overlay'",
    '[class.is-compact]': 'compact()',
  },
})
export class ProcessingLoaderComponent {
  readonly message = input('');
  readonly messages = input<readonly string[]>([]);
  readonly appearance = input<ProcessingLoaderAppearance>('inline');
  readonly compact = input(false);

  private readonly translations =
    inject(UiTranslationService).namespace<ProcessingLoaderTranslations>(
      'processingLoader',
    );
  private readonly selectedMessageIndex = Math.floor(
    Math.random() * DEFAULT_MESSAGE_COUNT,
  );

  protected readonly displayMessage = computed(() => {
    const explicitMessage = this.message().trim();
    if (explicitMessage) {
      return explicitMessage;
    }

    const customMessages = this.messages()
      .map((message) => message.trim())
      .filter((message) => message.length > 0);
    if (customMessages.length > 0) {
      return customMessages[this.selectedMessageIndex % customMessages.length];
    }

    return this.translations.tr(
      `message${String(this.selectedMessageIndex + 1).padStart(2, '0')}`,
    );
  });
}
